module.exports = __webpack_public_path__ + "img/14-onebg.ff3b5ce2.jpg";